import React from 'react';
import { $ } from '@starberry/components';
import PageHero from './PageHero';

export default {
    $: 'Text',
    children: 'Persona Property address2222',
}